import { SubFsmBuilder } from "little-fsm";
import { PaymentAttemptFsmContext } from "./PaymentAttemptFsmContext";
import { StartPayRequest } from "../../sdks/KBZPayMiniAppSDK";
import { PromoCodeVerifiedResponseDTO } from "../../apiclient/ApiDtos";

export type PaymentAttemptFsmScheme = {
    context: PaymentAttemptFsmContext,
    substates: [
        'initial',
        'viewing_terms',
        'payment_processing', 
        'payment_error', 
        'confirming_tentative_booking_lost',
        'applying_promo_code',
    ],
    events: {    
        "back": {},
        "tentative_booking_lost_accepted": {},
        "tentative_booking_lost_declined": {},
        "payment_terms_opened": {},
        "payment_terms_closed": {},
        "payment_initiated" : {},
        "payment_failed" : {errorMessage: string},
        "payment_error_acknowledged": {},
        "payment_completed" : {paymentParams: StartPayRequest, tentativeBookingId: string},
        "promo_code_entered": {promoCode: string},
        "promo_code_applied": {verifiedPromoResult: PromoCodeVerifiedResponseDTO},
        "promo_code_failed": {errorMessage: string}
        "promo_code_removed": {}
    }
}

// just simple identity function
const $I = (x: any) => x;

export function paymentAttemptSubFsmBuilder() : SubFsmBuilder<PaymentAttemptFsmScheme> {
    let subBuilder = new SubFsmBuilder<PaymentAttemptFsmScheme>(); 

    subBuilder.entrySubstate('initial')        

    subBuilder.substate("initial")
        .transition('payment_terms_opened', 'viewing_terms', (context, event) => context)
        .transition('payment_initiated', 'payment_processing', (context, event) => context)
        .transition('back', 'confirming_tentative_booking_lost', (context, event) => context)
        .transition('promo_code_entered', 'applying_promo_code',
            (context, event) => context.withEnteredPromoCode(event.promoCode))
        .transition('promo_code_removed', 'initial',
            (context, event) => context.withoutPromo())
        ;
      
    
    subBuilder.substate("viewing_terms")
        .transition('back', 'initial', (context, event) => context)
        .transition('promo_code_applied', 'initial', (context, event) => context)
        .transition('promo_code_failed', 'initial', (context, event) => context);

    subBuilder.substate("applying_promo_code")
        .transition('promo_code_applied', 'initial',
            (context, event) => context.withVerifiedPromoSuccessResult(event.verifiedPromoResult))
        .transition('promo_code_failed', 'initial',
            (context, event) => context.withPromoVerificationError())
        .transition('payment_terms_closed', 'initial', (context, event) => context);    
    
    subBuilder.substate('payment_processing')
        .completion('payment_completed', $I)
        .transition('payment_failed', "payment_error", (context, e) => context.withoutPromo());   
    
    subBuilder.substate('payment_error')
        .transition('payment_error_acknowledged', 'initial', $I)
    
    subBuilder.substate('confirming_tentative_booking_lost')
        .transition('back', "initial", (context, event) => context)
        .transition('tentative_booking_lost_declined', "initial", (context, event) => context)
        .termination('tentative_booking_lost_accepted', $I);  

    return subBuilder;
}